import type { SupabaseClient } from "@supabase/supabase-js";
import { ensureProfile } from "../profile/ensure-profile";
import { logAuth } from "./debug-log";

/**
 * Garantit la ligne `public.profiles` du compte connecté — et donc, par le
 * trigger `profiles_create_personal_project`, son projet personnel.
 *
 * Historiquement le profil n'était créé qu'au premier envoi réseau (synchro
 * d'une capture, import d'une transcription) : un compte tout neuf n'avait donc
 * ni profil ni projet personnel avant sa première synchro RÉUSSIE, d'où une
 * liste de projets vide et des échecs au premier usage. On le garantit
 * maintenant dès qu'une session existe.
 *
 * Ne jette JAMAIS : hors ligne au premier lancement, l'app doit rester
 * utilisable. L'échec part dans le journal d'auth (visible dans /debug/auth).
 * Retourne `true` seulement si le profil est confirmé côté serveur, pour que
 * l'appelant puisse retenter au prochain événement d'authentification.
 */
export async function ensureProfileForSession(
  client: SupabaseClient,
  user: { id: string; email: string | null | undefined },
): Promise<boolean> {
  try {
    const result = await ensureProfile(client, { id: user.id, email: user.email });
    if (result.ok) {
      logAuth("info", "profil garanti pour la session", { user: user.email });
      return true;
    }
    logAuth("warn", "échec de la garantie du profil", result.error);
    return false;
  } catch (err) {
    logAuth(
      "warn",
      "échec de la garantie du profil (exception)",
      err instanceof Error ? err.message : String(err),
    );
    return false;
  }
}
